<script lang="ts">
    import AppLayout from "@/layouts/AppLayout.svelte";
    import type Blocks from "@/schemas/public/Blocks";
    import type {Field, Lead} from "@/types/types";
    import type { DependencyMap } from '@/types/fieldDependency';
    import LeadKanban from "@/components/leads/LeadKanban.svelte";
    import CreateRecordModal from "@/components/CreateRecordModal.svelte";
    import Debug from '@/components/Debug.svelte';

    type StatusOption = {
        key: string;
        label: string;
        color: string;
        cssClass: string;
    };

    type Props = {
        blocks: (Blocks & { fields: Field[] })[];
        leads: Lead[];
        documentBlocks: (Blocks & { fields: Field[] })[];
        siteSurveyBlocks: (Blocks & { fields: Field[] })[];
        siteSurveyDependencyMap?: DependencyMap;
        statusOptions?: StatusOption[];
    };

    let {blocks, leads, documentBlocks, siteSurveyBlocks, siteSurveyDependencyMap = {}, statusOptions = []}: Props = $props();

    let breadcrumbs = $state([
        {title: 'Leads', href: route('leads.index')},
    ]);

    let showCreateLeadModal = $state(false);

    function openCreateLeadModal() {
        showCreateLeadModal = true;
    }

</script>

<svelte:head>
    <title>Leads</title>
</svelte:head>

<AppLayout {breadcrumbs}>
    <LeadKanban {leads} {blocks} {documentBlocks} {siteSurveyBlocks} {siteSurveyDependencyMap} {statusOptions} onAddNew={openCreateLeadModal} />

   <CreateRecordModal
        blocks={blocks}
        bind:show={showCreateLeadModal}
        entityTitle="Lead"
        createRoute="leads.store"
   />

</AppLayout>
